/* eslint-disable */
import { useSelector } from 'react-redux';
import { Icon } from '../../Icons';
import { sendAmplitudeEvents } from '../../../utils/common';
import { EventNames } from '../../../utils/events';

import './style.css';

function ZohoChatSupport() {
  const currentConfigurationQuickRun = useSelector(
    (state) => state.onboarding?.currentConfigurationQuickRun
  );
  let isQuickRunPage = window.location.pathname.indexOf('quick-run') !== -1;
  let isSamplePage = window.location.pathname.indexOf('sample') !== -1;
  let isYamlPage = window.location.pathname.indexOf('custom') !== -1;
  return (
    <>
      {/* <div
        className="ltw-bg-secondary ltw-flex ltw-items-center ltw-rounded	ltw-py-11px ltw-px-18px ltw-cursor-pointer ltw-flex ltw-gap-9px"
        onClick={() => {
          if (isSamplePage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK_SAMPLE_PAGE
            );
          } else if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK_YAML_PAGE
            );
          } else {
            sendAmplitudeEvents(EventNames.HYP_ONBOARDING_SUPPORT_CHAT_CLICK);
          }
          openZohoSalesIqChat();
        }}
        onKeyDown={openZohoSalesIqChat}
        role="button"
        tabIndex="0"
      >
        <Icon name="headphone" width="16" height="16" />
        <Typography
          variant="h2"
          fontType="ltw-font-normal"
          color="ltw-text-white"
          cursor="pointer"
        >
          TALK TO OUR AUTOMATION EXPERT
        </Typography>
      </div> */}
      <button
        onClick={(e) => {
          if (isQuickRunPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_QUICK_RUN_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
                ['testing framework']:
                  currentConfigurationQuickRun?.frameworkType,
                framework: currentConfigurationQuickRun?.framework?.name,
                language: currentConfigurationQuickRun?.framework?.language,
              }
            );
          } else if (isSamplePage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK_SAMPLE_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
              }
            );
          } else if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK_YAML_PAGE,
              {
                redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
              }
            );
          } else {
            sendAmplitudeEvents(EventNames.HYP_ONBOARDING_VIEW_DOC_CLICK, {
              redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
            });
          }
          window
            .open(process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK, '_blank')
            .focus();
        }}
        className="ltw-flex ltw-items-center ltw-border ltw-rounded-4px zoho-chart-button"
      >
        <Icon name="documentation" width="15" height="14" />
        <div className="zoho-chart-button-text">Docs</div>
      </button>
    </>
  );
}

export default ZohoChatSupport;
